import { formatDuration } from './formatDuration';

/**
 * Single source of truth for rendering an effect's remaining duration.
 *
 * Indefinite effects (e.g. SHADOWLIGHT) display as "active" — they are
 * consumed by an external trigger, not by tick decrement, so a tick count
 * would be misleading.
 */
export interface EffectDurationLike {
  ticksRemaining: number;
  indefinite: boolean;
}

export function formatEffectDuration(effect: EffectDurationLike): string {
  // Day-only mode — spell effects have no sub-tick fractional data, so no opts are passed.
  return effect.indefinite ? 'active' : formatDuration(effect.ticksRemaining);
}
